module.exports = __webpack_public_path__ + "static/media/helsinki-19.26fc6a45.jpg";